<agm-map style="width: 100%"
         [style.height]="height"
         [latitude]="mapView?.lat"
         [longitude]="mapView?.lng"
         [zoom]="zoomLevel"
         [mapTypeId]="mapTypeId"
         [mapTypeControl]='true'
         [streetViewControl]="false"
         (mapClick)="setLocation($event.coords)">
    <agm-marker *ngIf="location" [latitude]="location.lat" [longitude]="location.lng"></agm-marker>
</agm-map>
